import { CheckCircleFilled, CoffeeOutlined } from '@ant-design/icons';
import './DrinkItem.less';

const DrinkItem = ({ drink, isSelected, onClick, isSoldOut = false, customizations: drinkOptions = [] }) => {
	return (
		<div>
			<div
				className={`drink-item ${isSelected ? 'selected' : ''} ${isSoldOut ? 'sold-out' : ''}`}
				onClick={onClick}
			>
				<div className="drink-image-container">
					{drink.image ? (
						<img
							src={drink.image}
							alt={drink.name}
							className="drink-image"
						/>
					) : (
						<div className="drink-image-placeholder drink-icon-placeholder">
							<CoffeeOutlined className="drink-placeholder-icon" />
						</div>
					)}
					{isSoldOut && (
						<div className="sold-out-overlay">
							<span className="sold-out-badge">SOLD OUT</span>
						</div>
					)}
					{isSelected && !isSoldOut && (
						<div className="selected-indicator">
							<CheckCircleFilled className="selected-check-icon" />
						</div>
					)}
				</div>
				<div className="drink-details">
					<div className="drink-info">
						<div className="drink-name-row">
							<div className="drink-name-section">
								<h3 className="drink-name">{drink.name}</h3>
								<p className="drink-description">{drink.description}</p>
							</div>
							<p className="drink-price">{isSelected ? `$${drink.price.toFixed(2)}` : `+ $${drink.price.toFixed(2)}`}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DrinkItem;
